<div class="modal-container login-modal section-bg d-flex flex-column">
  <div class="modal-header bg-header border-0" mat-dialog-header>
    <div class="pb-3" mat-dialog-title>
      @switch (status) {
        @case (RequestStatus.PendingFriendsOfOman) {
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-warning"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span
            ><span class="text-primary">{{ "REQUEST_MESSAGES.YOUR_MEMBERSHIP_REQUEST_IS_STILL_PENDING" | translate }}</span>
          </h1>
        }
        @case (RequestStatus.ApprovedFriendsOfOman) {
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-approve mx-1"></span
            ><span class="text-primary">{{ "REQUEST_MESSAGES.YOUR_MEMBERSHIP_HAS_BEEN_APPROVED" | translate }}</span>
          </h1>
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-credit-card mx-1">
              <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
              <span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span>
              <span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span>
              <span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span>
            </span>
            <span class="text-primary">{{ "REQUEST_MESSAGES.PLEASE_COMPLETE_YOUR_PAYMENT_TO_PROCEED" | translate }}</span>
          </h1>
        }
        @case (RequestStatus.PendingTourismCompanies) {
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-warning"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span
            ><span class="text-primary">{{ "REQUEST_MESSAGES.YOUR_TOURISM_COMPANY_REQUEST_IS_STILL_PENDING" | translate }}</span>
          </h1>
        }
        @case (RequestStatus.ApprovedTourismCompanies) {
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-approve mx-1"></span
            ><span class="text-primary">{{ "REQUEST_MESSAGES.YOUR_TOURISM_COMPANY_HAS_BEEN_APPROVED" | translate }}</span>
          </h1>
          <h1 class="m-0 p-0 pt-3 font-20 text-center w-100">
            <span class="db-icon-credit-card mx-1"
              ><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span
              ><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span
              ><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span
              ><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span
            ></span>
            <span class="text-primary">{{ "REQUEST_MESSAGES.PLEASE_COMPLETE_YOUR_PAYMENT_TO_PROCEED" | translate }}</span>
          </h1>
        }
      }
    </div>
  </div>
</div>
